import React from 'react'
import Layout from "../../components/Layout/Layout"
import Banner from './components/Banner/Banner'

import Features from './components/Features/Features'
import Features2 from './components/Features/Features2'
import Service from './components/Service/Service'
import Roadmap from './components/RoadMap/RoadMap'
import Footer from './components/Footer/Footer'

import './LandingPage.scss';
import ScrollTop from '../../components/ScrollTop/ScrollTop'
import Mouse from '../../components/Mouse/Mouse'

function LandingPage() {
  return (
    <>
      <div id="wrapper">
        <div id="page" className="">
          {/* <HeroSection /> */}
          <Banner />
          {/* <AboutUs /> */}
          <Features />
          <Features2 />
          <Service />
          <Roadmap />
          <Footer />
          {/* <Contact
          latitude="36.822548"
          longitude="10.193105"
          placeQuery="Avaxia" /> */}
          {/* <Footer style={{ textAlign: 'center', backgroundColor:"#F8FAFC" }}>
          Avaxia ©{new Date().getFullYear()}
        </Footer> */}
        </div>
      </div>
      <Mouse />
      <ScrollTop />
    </>
  )
}

export default LandingPage